import React, {Component} from 'react'
import {withTranslation} from 'react-i18next'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import employeeService from '../../../services/Employee.service'
import {UserRoles} from '../../../constants'
import {actions as employeeActions} from '../../../actions/employee'

import {GenericDetailTitle} from "../common/dialogs/GenericDetailTitle"
import { LoadingButton } from '../common/LoadingButton'

import {Text} from '@amzn/stencil-react-components/text'
import {Checkbox, InputWrapper, LabelPosition} from '@amzn/stencil-react-components/form'
import {Col, Row} from '@amzn/stencil-react-components/layout'
import {Button, ButtonVariant} from '@amzn/stencil-react-components/dist/submodules/button'
import {MessageBanner, MessageBannerType} from '@amzn/stencil-react-components/message-banner'
import {IconDownload} from '@amzn/stencil-react-components/icons'
import {Flyout, FlyoutContent} from '@amzn/stencil-react-components/flyout'
import { LiveAnnouncer } from '@amzn/stencil-react-components/live-announcer'
export class AcceptAwardDialog extends Component {

  constructor(props) {
    super(props);
    this.acceptTermsCheckboxRef = React.createRef();
    this.state = {
      isAwardAgreementViewed: false,
      isAcceptTermsChecked: false,
      hasAcceptTermsError: false,
      showAgreementBanner: false,
      loadingDocumentArray: new Array(props.award.documents.length).fill(false)
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.award !== this.props.award) {
      this.clearState();
    }
  }

  clearState = () => {
    this.setState({
      isAwardAgreementViewed: false,
      isAcceptTermsChecked: false,
      hasAcceptTermsError: false,
      showAgreementBanner: false,
      loadingDocumentArray: new Array(this.props.award.documents.length).fill(false)
    });
  }

  setAcceptTermErrorState = (value) => {
    this.setState({
      hasAcceptTermsError: value
    })
  }

  setShowAgreementBannerState = (value) => {
    this.setState({
      showAgreementBanner: value
    })
  }

  onClickAwardDocument = (awardDocument, index) => {
    this.state.loadingDocumentArray[index] = true;
    if (awardDocument.award_agreement) {
      this.setState({
        isAwardAgreementViewed: true
      });
    }

    this.props.actions.employee.getDocument(this.props.employee.id, this.props.award.id, awardDocument.id).then(() => (
      this.state.loadingDocumentArray[index] = false
    ));
  }

  onClickAcceptButton = () => {
    if (!this.state.isAwardAgreementViewed) {
      this.setShowAgreementBannerState(true);
    } else if (this.state.isAcceptTermsChecked) {
      this.props.onButtonPress();
    } else if (!this.state.isAcceptTermsChecked) {
      this.setAcceptTermErrorState(true);
      this.acceptTermsCheckboxRef.current?.focus();
    }
  }

  handleCheckboxChange = event => {
    this.setState({
      isAcceptTermsChecked: !this.state.isAcceptTermsChecked
    });
  };

  createAwardDocumentDownloadButton = (awardDocument, index) => {
    return (
      <LoadingButton
        onClick={() => this.onClickAwardDocument(awardDocument, index)}
        variant={ButtonVariant.Secondary}
        icon={<IconDownload aria-hidden={true} />}
        key={"awardDocumentButton_" + index}
        text={this.state.loadingDocumentArray[index] ? this.props.t('Loading.Loading') : awardDocument.title}
        loading={this.state.loadingDocumentArray[index]}
      />
    );
  }

  createAcceptAwardCheckBox = (t) => {
    return (
      <Row margin={{top: 32}} gridGap="S200">
        <InputWrapper
          id="acceptTermsCheckbox"
          labelText={t("AcceptAwardDialog.AcceptTerms")}
          labelPosition={LabelPosition.Trailing}
          footer={this.state.hasAcceptTermsError ? t("AcceptAwardDialog.AcceptTermsErrorMsg") : null}
          error={this.state.hasAcceptTermsError}
          required
        >
          {inputProps =>
            <Checkbox
              ref={this.acceptTermsCheckboxRef}
              checked={this.state.isAcceptTermsChecked}
              disabled={!this.state.isAwardAgreementViewed}
              onChange={this.handleCheckboxChange}
              {...inputProps}
            />
          }
        </InputWrapper>
      </Row>
    )
  }

  render() {
    const { t, employee, award } = this.props;

    if (!award) {
      return null;
    }

    const viewOnly = employeeService.hasRole(employee.roles, UserRoles.ACCEPT_AWARD_VIEW) ? true : false;

    return (
      <Flyout dataTestId="AcceptAwardDialog" isOpen={this.props.visible} close={this.props.onCloseDialog}>
        <LiveAnnouncer>
          <FlyoutContent
            titleText={t('AcceptAwardDialog.Title', {award_type: award.amazon_award_name})}
            closeButtonAltText="Close Button For Accept Award Dialog"
            onCloseButtonClick={this.props.onCloseDialog}
            buttons={[
              <Button onClick={this.props.onBackButtonPress} variant={ButtonVariant.Secondary}>
                {t("AcceptAwardDialog.BackButton")}
              </Button>,
              <LoadingButton
                onClick={this.onClickAcceptButton}
                disabled={viewOnly}
                variant={ButtonVariant.Primary}
                text={t("AcceptAwardDialog.AcceptButton")}
                loading={this.props.loading}
              />
            ]}
          >
            <Col gridGap="S300" height="100%">
              {this.state.showAgreementBanner &&
                <MessageBanner type={MessageBannerType.Informational} aria-live="polite">
                  {t("AcceptAwardDialog.ViewAgreementText")}
                </MessageBanner>
              }
              {this.props.error &&
                <MessageBanner type={MessageBannerType.Error} aria-live="polite">
                  {t('UnacceptedStockAwards.FailAcceptedAwardMessage')}
                </MessageBanner>
              }

              <GenericDetailTitle
                title={t("AcceptAwardDialog.AwardDocumentsSection")}
              />
              {award.documents.map((doc, index) => {
                return this.createAwardDocumentDownloadButton(doc, index)
              })}

              <GenericDetailTitle
                title={t("AcceptAwardDialog.TermsAndConditionsSection")}
              />
              <Text>{t("AcceptAwardDialog.DialogTextContent")}</Text>

              {this.createAcceptAwardCheckBox(t)}
            </Col>
          </FlyoutContent>
        </LiveAnnouncer>
      </Flyout>
    );
  }
}

const mapState = state => ({
  employee: state.employee
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
  }
});

export default connect(mapState, mapDispatchToProps)(withTranslation('translationsV2')(AcceptAwardDialog));
